module.exports = __webpack_public_path__ + "assets/certificate_pdf/ssa_112_26.f2defe4b.pdf";